import { Typography } from "@mui/material";
import QueryPreservingLink from "../../components/QueryPreservingLink";
import { isEmpty } from "lodash";
import React from "react";

const Header = ({ postsCategory, postsTag, postsAuthor, title }) => {
  if (isEmpty(postsCategory) && isEmpty(postsAuthor) && isEmpty(postsTag)) {
    return (
      <Typography
        sx={{
          fontWeight: 900,
          fontSize: "24px",
          color: "#6a27e8",
        }}
        variant="h4"
      >
        {title}
      </Typography>
    );
  }

  if (!isEmpty(postsCategory) && !isEmpty(postsAuthor) && !isEmpty(postsTag)) {
    return (
      <QueryPreservingLink to="/blog">
        <Typography variant="h4">Back to blog</Typography>
      </QueryPreservingLink>
    );
  }

  if (!isEmpty(postsCategory)) {
    return (
      <Typography
        variant="h4"
        sx={{
          fontWeight: 900,
          fontSize: "24px",
          color: "#6a27e8",
        }}
      >
        {`Recent Posts of ${postsCategory.name}`}
      </Typography>
    );
  }

  if (!isEmpty(postsTag)) {
    return (
      <Typography
        variant="h4"
        sx={{
          fontWeight: 900,
          fontSize: "24px",
          color: "#6a27e8",
        }}
      >{`Recent Posts of ${postsTag.name}`}</Typography>
    );
  }

  if (!isEmpty(postsAuthor)) {
    return (
      <Typography
        variant="h4"
        sx={{
          fontWeight: 900,
          fontSize: "24px",
          color: "#6a27e8",
        }}
      >
        {`Recent Posts of ${postsAuthor.name}`}
      </Typography>
    );
  }

  return null;
};

export default Header;
